import { getYoutubeId } from "../../shared/utilities/youtube";
import type { SectionRenderProps } from "../renderer/types";

export function LiveStreamingSection({ data, copy }: SectionRenderProps) {
  if (!data.liveStreaming.enabled || !data.liveStreaming.url) return null;
  const videoId = getYoutubeId(data.liveStreaming.url);
  if (!videoId) return null;
  return (
    <section className="livestream section-inner" id="liveStreaming">
      <div className="section-heading"><p className="eyebrow">{copy.livestream}</p><h2 data-editor-section="liveStreaming" data-editor-field="liveStreaming.title">{data.liveStreaming.title}</h2><p className="section-copy" data-editor-section="liveStreaming" data-editor-field="liveStreaming.description">{data.liveStreaming.description}</p></div>
      <div className="livestream-frame"><iframe src={`https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?rel=0&playsinline=1`} title={data.liveStreaming.title} loading="lazy" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" allowFullScreen /></div>
    </section>
  );
}
